import { getDesktopSearchConfig } from "@/pages/consumption/view/consumer-overview/config/desktop-search-config";
import { useQuery } from "react-query";
import { ISelectSearchConfig } from "@/components/dynamic-form";

const searchConfig = getDesktopSearchConfig();
export function useDesktopSearchConfig() {
  useUserNameConfig();

  return { searchConfig };
}

export function useUserNameConfig() {
  const { data } = useQuery<{ userName: string; userId: number }[]>(
    "/api/rendering/task/renderingTask/loadingUserName"
  );

  const options = data?.map((u) => ({ label: u.userName, value: u.userId }));

  const config = searchConfig.find(
    (c) => c.field === "userId"
  ) as ISelectSearchConfig;
  if (config?.props) {
    config.props.options = options;
  }
}
